export default __webpack_public_path__ + "static/media/ic_gmx_40.3c2fa0d4.svg";